// extracted by mini-css-extract-plugin
export var buttonContent = "_3a-0";
export var centered = "_3a-1";
export var centeredFlex = "_3a-2";
export var errorText = "_3a-3";
export var icon = "_3a-4";
export var iconButtonContent = "_3a-5";
export var monospace = "_3a-6";
export var padded = "_3a-7";